import { useId } from 'react';

import { MarkdownRenderer } from '#core/components/shared/MarkdownRenderer.tsx';
import type { MarkdownSpec } from '#core/lib/expr/ops/dashboard/value.ts';

import classes from './MarkdownPanel.module.css';
import { TileFrame } from './TileFrame.tsx';

export function MarkdownPanel({ spec }: { spec: MarkdownSpec }) {
  const tileId = useId();
  return (
    <TileFrame id={tileId} inspect={() => ({ spec })} name="markdown">
      <div className={classes.markdown}>
        <MarkdownRenderer className={classes.markdownContent} content={spec.content} />
      </div>
    </TileFrame>
  );
}
